import Cookies from 'js-cookie';
import { LOGIN_SUCCESS, LOGIN_ERROR, LOGOUT, CHANGE_LANG } from 'context/actions/auth';

let user;
if (process.browser) {
    user = JSON.parse(localStorage.getItem('user'));
}

let lang = 'mn';
if (typeof window !== 'undefined') {
    const chosenLang = Cookies.get('chosen_lang');
    if (chosenLang) lang = chosenLang;
}

const initialState = user ? { loggedIn: true, user, lang: lang } : { lang: lang };

const reducer = (state, action) => {
    switch (action.type) {
        case LOGIN_SUCCESS:
            Cookies.set('auth_token', action.data.token, { expires: 7 });
            localStorage.setItem('user', JSON.stringify(action.data));
            return {
                loggedIn: true,
                user: action.data,
                row: action.data.userId,
            };
        case LOGIN_ERROR:
            localStorage.removeItem('user');
            Cookies.remove('auth_token');
            return { loggedIn: false };
        case LOGOUT:
            localStorage.removeItem('user');
            Cookies.remove('auth_token');
            return { loggedIn: false };

        case CHANGE_LANG:
            return { ...state, lang: action.data };
        default:
            return state;
    }
};

const authReducer = [reducer, initialState];

export default authReducer;
